<template>
    <div class="product-header">
        <template v-for="blokEl in blok.Layout" :key="blokEl._uid">
            <component :is="blokEl.component" :blok="blokEl" class="product-item" />
        </template>
    </div>
</template>

<script setup lang="ts">
defineProps<{ blok: any }>();
</script>

<style lang="postcss" scoped>
.product-header {
    @apply flex flex-col lg:flex-row mb-2 mt-2 w-full bg-gray rounded-md border-2 border-gray-300;

    .product-item {
        :deep(.slot) {
            @apply p-2 border-l-2 border-gray-300;
            &:first-child {
                @apply border-l-0;
            }
        }
    }

    :deep(.carousel-section) {
        @apply !p-0;
        .carousel .carousel__slide img {
            @apply w-auto lg:w-full;
        }
        .carousel__viewport {
            @apply lg:max-h-[335px];
            .carousel__track {
                @apply lg:max-h-[335px];
            }
        }
        .container {
            @apply p-0;
            .carousel__prev {
                @apply left-4 right-auto;
                --tw-translate-x: 0;
            }
            .carousel__next {
                @apply right-4 left-auto;
            }
        }
    }
}
</style>
